module.exports = __webpack_public_path__ + "static/media/Page01.e3aa9a57.jpg";